/***
 * Created on 2024/2/19
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import ModalDialog from "../../../../common/modal_dialog/modalDialog";
import google_store_svg from "../../../../../static/img/utils/banner-googleplay.svg";
import google_store_qrcode_svg from "../../../../../static/img/utils/qrcode-googleplay.png";
import apple_store_svg from "../../../../../static/img/utils/banner-appstore.svg";
import apple_store_qrcode_svg from "../../../../../static/img/utils/qrcode-appstore.png";
import qnap_authenticator  from "../../../../../static/img/utils/logo-qnap-authenticator.svg";
import {useTranslation} from "react-i18next";
import QnapAuthAppStepContent from "./qnap_auth_app_step_content";

function InstallQnapAuthApp({dispatch, state, ...props}) {
    const {t, i18n} = useTranslation();
    const goToAppleStore = () => {
        window.open(
            `https://apps.apple.com/tw/app/qnap-authenticator/id1620302345?l=${i18n.language}`,
            "_blank"
        )
    }

    const goToGoogleStore = () => {
        window.open(
            `https://play.google.com/store/apps/details?id=com.qnap.qnapauthenticator&hl=${i18n.language}`,
            "_blank"
        )
    }

    const onNext = async () => {
        dispatch({type: state.openAfterInstallApp, value: true});
    }

    return (
        <ModalDialog {...props} title={t('@Verify through an app@')} submitAction={onNext} withWizardMode={true} withStepBar={true} stepContent={() => QnapAuthAppStepContent({state, step: 1})}>
            <div className="dialog-content dialog-content--two-step">
                <p className="!mb-16" dangerouslySetInnerHTML={{
                    __html: t('@If you have not yet install any authentication app, you may need to download {{qnap_authenticator}} for your mobile device.@', {
                        qnap_authenticator: `<a href="${window.acc_mf.account.QNAP_AUTHENTICATOR_APP}" target="_blank">QNAP Authenticator</a>`
                    })
                }}></p>
                <div className="two-step--install">
                    <div className="mb-10"><img src={qnap_authenticator} alt="" /></div>
                    <div className="text-align-center">
                        <div className="two-step--install__app-item" onClick={goToAppleStore}>
                            <div className="two-step--install__app-item__qrcode">
                                <img src={apple_store_qrcode_svg} alt=""/>
                            </div>
                            <div className="two-step--install__app-item__banner">
                                <img src={apple_store_svg} alt="" />
                            </div>
                        </div>
                        <div className="two-step--install__app-item" onClick={goToGoogleStore}>
                            <div className="two-step--install__app-item__qrcode">
                                <img src={google_store_qrcode_svg} alt="" />
                            </div>
                            <div className="two-step--install__app-item__banner">
                                <img src={google_store_svg} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ModalDialog>
    );
}

export default InstallQnapAuthApp;